import cookie from 'cookie';

import { emptyObject } from 'Lib/constants/placeholder';
import { debugCookie as debug } from 'Lib/debug';

const ONE_WEEK = 60 * 60 * 24 * 7;

let instance;

export class Cookies {
  cookies: {
    [key: string]: string;
  };

  constructor(cookies: Record<string, string> = emptyObject) {
    if (__CLIENT__) {
      this.cookies = cookie.parse(document.cookie) || emptyObject;
    } else {
      // node, parse from req.headers.cookies
      this.cookies = cookies;
    }
  }

  get = (key: string): string => {
    const value = this.cookies[key];
    debug('Getting cookie', key, value);
    return value;
  };

  set = (
    key: string,
    value: string,
    options: cookie.CookieSerializeOptions = { path: '/', maxAge: ONE_WEEK }
  ): void => {
    debug('Setting cookie', key, value);
    this.cookies[key] = value;

    if (__CLIENT__) {
      try {
        document.cookie = cookie.serialize(key, value, options);
      } catch (e) {
        debug('Error writing cookie', e);
      }
    }
  };
}

export default function getCookiesInstance(cookies: Record<string, string> = emptyObject) {
  if (!instance) {
    instance = new Cookies(cookies);
  }
  return instance;
}
